import { render, staticRenderFns } from "./AreaOfExpense.vue?vue&type=template&id=4a00ce70&"
import script from "./AreaOfExpense.vue?vue&type=script&lang=js&"
export * from "./AreaOfExpense.vue?vue&type=script&lang=js&"
import style0 from "./AreaOfExpense.vue?vue&type=style&index=0&id=4a00ce70&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports